import * as React from 'react'
import cx from 'classnames'

export interface SvgIconProps {
	collectionName: string
	iconName: string
	className?: string
	style?: React.CSSProperties
}

export function SvgIcon(props: SvgIconProps) {
	const url = `/stampede/svgsprite?collection=${props.collectionName}#${props.iconName}`

	return (
		<svg
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			className={cx('fill-current', props.className)}
			style={props.style}
		>
			<use xlinkHref={url} href={url} />
		</svg>
	)
}
